import React from "react";
import { useLang } from "../LangContext";
import { useReveal } from "../hooks/useReveal";
import { useContact } from "../ContactContext";
import { ArrowRight, Mail } from "lucide-react";

export const FinalCTA = () => {
  const { t } = useLang();
  const ref = useReveal();
  const { openContact } = useContact();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 lg:py-32 reveal"
      ref={ref}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2.5rem] glass-strong p-10 sm:p-14 lg:p-20 text-center">
          {/* Gradient glow */}
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[140%] h-72 bg-baj-grad opacity-40 blur-3xl" />
          <div className="absolute inset-0 baj-noise" />

          <div className="relative">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
              {t.finalCta.title.split(" ").slice(0, -1).join(" ")}{" "}
              <span className="text-baj-grad">
                {t.finalCta.title.split(" ").slice(-1)}
              </span>
            </h2>
            <p className="mt-6 max-w-2xl mx-auto text-lg text-slate-300 leading-relaxed">
              {t.finalCta.text}
            </p>

            <div className="mt-10 flex flex-wrap justify-center gap-3 sm:gap-4">
              <a
                href="#follow-me"
                onClick={scrollTo("#follow-me")}
                className="btn-primary"
                data-testid="final-cta-follow"
              >
                {t.finalCta.cta1}
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="#follow-me"
                onClick={scrollTo("#follow-me")}
                className="btn-ghost"
                data-testid="final-cta-discover"
              >
                {t.finalCta.cta2}
              </a>
              <button
                type="button"
                onClick={() => openContact()}
                className="btn-ghost"
                data-testid="final-cta-contact"
              >
                <Mail className="w-4 h-4" />
                {t.finalCta.cta3}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
